import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import misc from '../../misc';

export class LocationEdit extends Component {
  renderHeading() {
    const { initialValues, isLoading, submitting } = this.props;

    if (!submitting && isLoading) {
      return null;
    }
    if (typeof initialValues === 'undefined') {
      return <h5>New Location</h5>;
    }

    return <h5>{initialValues.get('name')}</h5>;
  }

  renderForm() {
    const {
      handleSubmit,
      error,
      pristine,
      submitting,
      isLoading,
      initialValues
    } = this.props;

    return (
      <div className="row justify-content-md-center">
        <form
          className="container"
          onSubmit={handleSubmit(this.props.onSubmit)}
        >
          {this.renderHeading()}
          {error && <misc.components.Alert message={error} />}
          <Field
            component={misc.components.FormField}
            name="name"
            id="name"
            type="input"
            label="Location name"
            required
            autoFocus
          />
          <div className="row">
            <div className="col">
              <button
                type="button"
                onClick={this.props.onCancel}
                className="btn btn-secondary btn-block"
              >
                Cancel
              </button>
            </div>
            <div className="col">
              <misc.components.LoadingButton
                disabled={pristine || submitting}
                loading={isLoading}
              >
                {typeof initialValues === 'undefined' ? 'Add' : 'Save'}
              </misc.components.LoadingButton>
            </div>
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { isLoading, isError, errorMessage, submitting } = this.props;
    return (
      <div className="col-md-9 content">
        {!submitting && isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}
        {this.renderForm()}
      </div>
    );
  }
}

LocationEdit.propTypes = {
  initialValues: ImmutablePropTypes.contains({
    id: PropTypes.string.isRequired,
    name: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

LocationEdit.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export const validate = values => {
  const errors = {};

  // Name
  if (!values.get('name')) {
    errors.name = 'Name is required.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'locationForm'
})(LocationEdit);



// WEBPACK FOOTER //
// ./src/modules/locations/components/LocationEdit.js